import { createFeatureSelector, createSelector } from "@ngrx/store";
import { SignInStore } from "../interfaces/sign-in-store.interface";

export const signInStateSelector = createFeatureSelector<SignInStore>('signIn');
export const signInStoreSelector = createSelector(signInStateSelector, (state: SignInStore) => state);
export const signInPendingSelector = createSelector(signInStateSelector, (state: SignInStore) => state.pending);
export const signInPreviousRouteSelector = createSelector(signInStateSelector, (state: SignInStore) => state.previousRoute);